import { Stack, XStack } from '@mythical/ui'
import { getItemStyles, getWrapperStyles, defaultGridConfig as defaultConfig } from './lib'
import { GridProps } from './GridProps'

/**
 * Generic Grid component that renders a list of items in a grid layout.
 * It works by setting padding on each of the item and offsetting it with negative margin on the wrapper.
 */
export const Grid: <T>(props: GridProps<T>) => React.ReactElement<GridProps<T>> | null = (
  props
) => {
  const { items, keyExtractor, renderItem, options, wrapperProps } = props

  const itemStyles = {
    fs: 1,
    fg: 0,
    ...getItemStyles({ ...defaultConfig, ...options }),
    $gtXxxs: getItemStyles(options?.$gtXxxs),
    $gtXxs: getItemStyles(options?.$gtXxs),
    $gtXs: getItemStyles(options?.$gtXs),
    $gtSm: getItemStyles(options?.$gtSm),
    $gtMd: getItemStyles(options?.$gtMd),
    $gtLg: getItemStyles(options?.$gtLg),
  }

  const wrapperStyles = {
    ...getWrapperStyles({ ...defaultConfig, ...options }),
    $gtXxxs: getWrapperStyles(options?.$gtXxxs),
    $gtXxs: getWrapperStyles(options?.$gtXxs),
    $gtXs: getWrapperStyles(options?.$gtXs),
    $gtSm: getWrapperStyles(options?.$gtSm),
    $gtMd: getWrapperStyles(options?.$gtMd),
    $gtLg: getWrapperStyles(options?.$gtLg),
  }

  if (!items || items.length === 0) return null

  return (
    <XStack fs={1} flexWrap="wrap" {...wrapperStyles} {...wrapperProps}>
      {items.map((item, i) => (
        <Stack key={keyExtractor(item, i)} {...itemStyles}>
          {renderItem(item, i)}
        </Stack>
      ))}
    </XStack>
  )
}
